module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"carrier-services":"Carrier Services","failed-delete-carrier-service":"Failed to delete carrier service"}}')
  delete Component.options._Ctor
}
